// Column Types
export const SINGLE_SELECT = 'single_select';
export const MULTI_SELECT = 'multi_select';
export const TEXT = 'text';
export const CONSTANT = 'constant';
export const DATE = 'date';
export const FORMAT_CONTROLLED = 'format_controlled';
export const PARENT_FIELD = 'parent_field';

// Grid Configuration
export const ROW_COUNT_LIMIT = 120;
export const GRID_URL_BUILDER_ID = 'grid-mode-url-builder';
export const HEADER_HEIGHT = 60;

// Cell Styles
export const DISABLED_CELL_STYLE = { backgroundColor: '#eeeeee' };
export const ENABLED_CELL_STYLE = { backgroundColor: '#ffffff' };

// Default Column Definition
export const defaultColDef = {
  width: 200,
  minWidth: 125,
  flex: 1,
  filter: false,
  sortable: false, // Explicitly disable sorting (AG Grid 31 has it enabled by default)
  resizable: true, // Keep resizable enabled (AG Grid 31 default)
  hide: false,
  floatingFilter: false,
  enableCellChangeFlash: false,
  suppressPaste: true, // Block paste by default, override for specific columns
};
